<script setup lang="ts"></script>

<template>
  <div class="w-full">
    <slot />
  </div>
</template>
